import { combineReducers } from '@reduxjs/toolkit'

import { reducer as questions } from './questions'
import { reducer as plans } from '../plan/plan'
import { reducer as menus } from './menus'
import { reducer as precautions } from './precaution'

export default combineReducers({ questions, plans, menus, precautions })
